import i18n from "i18next";
import { detectLanguage } from "./getLanguageFromUrl"; // ton util async pour détecter langue
import { SupportedLocale } from "./locales";

/**
 * Retourne la langue courante sous forme de string (ex: 'fr-FR', 'en-GB')
 * Priorité :
 * 1. i18n.language si déjà initialisé
 * 2. Détection via l'URL
 * 3. fallback 'fr-FR'
 */
export async function getCurrentLanguage(): Promise<SupportedLocale> {
    if (i18n.isInitialized && i18n.language) {
        return i18n.language as SupportedLocale;
    }

    // si i18n pas encore initialisé, détecte via l'URL
    const lang = await detectLanguage();
    return lang;
}
